/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnalyticsLookup,
  AnalyticsLookup$inboundSchema,
} from "./analyticslookup.js";

export const AnalyticsFieldRole = {
  Dimension: "dimension",
  Measure: "measure",
} as const;
export type AnalyticsFieldRole = ClosedEnum<typeof AnalyticsFieldRole>;

export const Type = {
  String: "string",
  Int64: "int64",
  Float64: "float64",
} as const;
export type Type = ClosedEnum<typeof Type>;

/**
 * One queryable field on a dataset.
 */
export type AnalyticsField = {
  /**
   * Ops a field admits: aggregations on a measure, count_distinct on a dimension
   */
  aggregations?: Array<string> | undefined;
  /**
   * Part of the query the dataset opens on: a default dimension is in the opening group-by
   */
  default: boolean;
  /**
   * What the field is and which producers fill it, when the catalog has something to say beyond the name
   */
  description?: string | undefined;
  /**
   * A per-project map a dimension reads through at query time: a reported value with an entry shows as its target, the rest show as reported.
   */
  lookup?: AnalyticsLookup | undefined;
  name: string;
  /**
   * Filter operators a dimension admits
   */
  operators?: Array<string> | undefined;
  role: AnalyticsFieldRole;
  type: Type;
  /**
   * Unit of a measure, when it has one
   */
  unit?: string | undefined;
};

/** @internal */
export const AnalyticsFieldRole$inboundSchema: z.ZodMiniEnum<
  typeof AnalyticsFieldRole
> = z.enum(AnalyticsFieldRole);

/** @internal */
export const Type$inboundSchema: z.ZodMiniEnum<typeof Type> = z.enum(Type);

/** @internal */
export const AnalyticsField$inboundSchema: z.ZodMiniType<
  AnalyticsField,
  unknown
> = z.object({
  aggregations: z.optional(z.array(z.string())),
  default: z.boolean(),
  description: z.optional(z.string()),
  lookup: z.optional(AnalyticsLookup$inboundSchema),
  name: z.string(),
  operators: z.optional(z.array(z.string())),
  role: AnalyticsFieldRole$inboundSchema,
  type: Type$inboundSchema,
  unit: z.optional(z.string()),
});

export function analyticsFieldFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsField, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsField$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsField' from JSON`,
  );
}
